import IC_COLLECTOR_FAIL from "@/assets/common/ic_collect_fail.svg?react";

export interface IVoiceCollectFailProps {
  speakerName?: string;
  handleReCollect: () => void;
  errMsg: string;
  samplingRate?: number;
}

const VoiceCollectFail: React.FC<IVoiceCollectFailProps> = ({
  speakerName,
  handleReCollect,
  errMsg,
  samplingRate,
}) => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <IC_COLLECTOR_FAIL className="w-12 h-12" />
      <div className="mt-6 font-600 text-size-4.5 text-mx-secondary">
        {speakerName}
        <span className="font-400"> {errMsg}</span>
      </div>
      {samplingRate !== undefined && (
        <div className="mt-0.5 font-400 text-size-3.5 text-mx-tertiary lh-7.5">
          {`当前采样率${samplingRate}%`}
        </div>
      )}
      <div
        className="mt-12 cursor-pointer flex items-center justify-center w-36.5 rounded-2.5 h-12 bg-#4981f2 text-#fff text-size-3.5"
        onClick={handleReCollect}
      >
        重新采集
      </div>
    </div>
  );
};

export default VoiceCollectFail;
